/**
 * ============================================================
 * CENTRAL SERVER CONFIGURATION
 * ============================================================
 *
 * Current server structure:
 *
 * https://sansha.in/
 *      |
 *      └── api/
 *           ├── popup_active.php
 *           ├── other PHP APIs
 *           └── uploads/
 *                ├── gallery/
 *                ├── popup/
 *                └── other files
 *
 * There is NO /myapp folder.
 *
 * For another client, normally only change SITE_BASE_URL.
 * ============================================================
 */


// ============================================================
// WEBSITE / SERVER
// ============================================================

export const SITE_BASE_URL =
    "https://webcontrol.suvidham.in";


// ============================================================
// API
// ============================================================

export const API_BASE_URL =
    `${SITE_BASE_URL}/api`;


// ============================================================
// API UPLOADS
// ============================================================

export const UPLOADS_API_URL =
    `${API_BASE_URL}/uploads`;


// ============================================================
// GALLERY IMAGES
// ============================================================

export const GALLERY_IMAGE_URL =
    `${API_BASE_URL}/uploads/gallery/`;


// ============================================================
// FILE URL HELPER
// ============================================================

export const getAppFileUrl = (filePath = "") => {

    let value =
        String(filePath || "").trim();


    // No file
    if (!value) {

        return "";

    }


    // Already full URL
    if (
        /^https?:\/\//i.test(value)
    ) {

        return value;

    }


    // Remove starting /
    value =
        value.replace(/^\/+/, "");


    /*
    ============================================================
    If database already contains:
    
    api/uploads/photo.jpg
    
    Result:
    https://sansha.in/api/uploads/photo.jpg
    ============================================================
    */

    if (
        value.startsWith("api/")
    ) {

        return `${SITE_BASE_URL}/${value}`;

    }


    /*
    ============================================================
    If database contains:
    
    uploads/photo.jpg
    
    Result:
    https://sansha.in/api/uploads/photo.jpg
    ============================================================
    */

    if (
        value.startsWith("uploads/")
    ) {

        return `${API_BASE_URL}/${value}`;

    }


    /*
    ============================================================
    Any other relative path
    
    Example:
    popup/photo.jpg
    
    Result:
    https://sansha.in/api/popup/photo.jpg
    ============================================================
    */

    return `${API_BASE_URL}/${value}`;

};